export default __webpack_public_path__ + "static/media/skippedmeal_4.5ed988a1.jpg";